import { render, staticRenderFns } from "./EmployeesOverview.vue?vue&type=template&id=3fa3414c&"
import script from "./EmployeesOverview.vue?vue&type=script&lang=js&"
export * from "./EmployeesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports